<template>
  <button
    :class="{[variant]: true, 'disabled': disabled, 'no-padding': noPadding}"
    :disabled="disabled"
    class="pc-btn"
    @click="$emit('click')"
  >
    <icu-icon v-if="iconLeftName" class="icu-btn__icon icon-left" :icon-name="iconLeftName" />
    <slot></slot>
    <icu-icon v-if="iconRightName" class="icu-btn__icon icon-right" :icon-name="iconRightName" />
  </button>
</template>

<script>
import IcuIcon from '@/components/common/IcuIcon.vue'
export default {
  name: 'PcButton',
  components: { IcuIcon },
  props: {
    variant: {
      type: String,
      default: 'main'
    },
    noPadding: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    iconLeftName: {
      type: String,
      default: ''
    },
    iconRightName: {
      type: String,
      default: ''
    },
  }
}
</script>

<style scoped lang="scss">
@import "~@/assets/scss/theme.scss";

.pc-btn {
  padding: 0 40px;
  min-height: 64px;
  height: 64px;
  border-radius: 16px;
  font-size: 16px;
  font-weight: 700;
  box-shadow: 0px 5px 9px 0px #02182D29;
  color: $default-text;
  display: flex;
  justify-content: center;
  align-items: center;

  &.void {
    background: $btn-void-bg;
  }

  &.main {
    background: $btn-main-bg;
    color: $white;
  }

  &.dark {
    background: $btn-dark-bg;
    color: $gray;
  }

  &.light {
    background: $btn-light-bg;
  }

  &.error {
    background: $btn-error-bg

  }
  &.disabled {
    background: $btn-disabled-bg;
  }
  &.left {
    justify-content: flex-start;
  }
  &.right {
    justify-content: flex-end;
  }
  &.no-padding {
    padding: 0;
  }

  .icon-left {
    margin-right: 12px;
    flex-shrink: 0;
  }
  .icon-right {
    margin-left: 12px;
  }
}

</style>
